export type Ingredient =
  | 'frog'
  | 'ghostpipe'
  | 'honey'
  | 'moonwater'
  | 'mushroom'
  | 'rose'
  | 'waterlily'

export const ingredientOptions: Array<Ingredient> = [
  'frog',
  'ghostpipe',
  'honey',
  'moonwater',
  'mushroom',
  'rose',
  'waterlily'
]
